/**
 * The Sharpenny gold palette. Everything coin-shaped reads from here so
 * the header chip, the reward cards and the celebration confetti are the
 * same metal.
 */
export const GOLD = {
  deep: '#7a4f10',
  dark: '#8a5a14',
  mid: '#c99a2e',
  light: '#f5d67a',
  pale: '#fff4cf',
  ink: '#5a3a08',
}

// Order matters: Shine Border lays these out along its radial gradient.
export const SHINE_COLORS = [GOLD.dark, GOLD.light, GOLD.pale, GOLD.mid]

export const GRADIENT_STROKE = [
  {offset: '0', color: GOLD.dark},
  {offset: '0.45', color: GOLD.mid},
  {offset: '0.55', color: GOLD.light},
  {offset: '1', color: GOLD.dark},
]
